<template>
  <div v-if="!data.delete" class="grid" style="display: flex;">
    <div
      class="mt-md mb-sm grid__cell col1-of-12"
      style="margin-left: 0; float: left; display: flex; padding-left: 0;"
    >
      <button
        v-if="!first"
        @click="move(-1)"
        type="button"
        class="fw-bold fs-sm fc-violet"
        style="font-size: 18px;"
        tabindex="-1"
      >
        <i class="fa fa-chevron-up" aria-hidden="true"></i>
      </button>
      <button
        v-if="!last"
        @click="move(1)"
        type="button"
        class="fw-bold fs-sm fc-violet"
        style="font-size: 18px;"
        tabindex="-1"
      >
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </div>
    <div
      class="dashboard-fieldset grid-cell col11-of-12 grid grid--middle shadow"
      style="padding: 0.5rem; margin-bottom: 1rem;"
    >
      <button
        @click="askConfirmation"
        type="button"
        class="fw-bold fs-sm fc-alert mt-xs mr-xs fl-right"
        style="font-size: 0.85rem;"
        tabindex="-1"
      >
        Delete <i class="fa fa-times-circle" aria-hidden="true"></i>
      </button>
      <div
        class="grid__cell col10-of-12--small col10-of-12--medium col10-of-12--large-up"
        style="padding-left: 0.5em;"
      >
        <label class="mb-sm">
          <input
            data-hj-allow
            @change="update($event, 'name')"
            type="text"
            :value="data.name"
            placeholder="Filter Name"
          />
        </label>

        <div class="custom-radio mb-sm" style="margin-bottom: 0.75em;">
          <input
            :id="'multi' + data.order + data.id"
            @change="updateCheck($event, 'multiple')"
            type="checkbox"
            :checked="data.multiple"
          />
          <label :for="'multi' + data.order + data.id"
            >Allow multiple values for agencies</label
          >
        </div>
        <div class="custom-radio mb-sm" style="margin-bottom: 0.75em;">
          <input
            :id="'multidir' + data.order + data.id"
            @change="updateCheck($event, 'multipleAtDirectory')"
            type="checkbox"
            :checked="data.multipleAtDirectory"
          />
          <label :for="'multidir' + data.order + data.id"
            >Allow multiple values at directory</label
          >
        </div>
        <div class="custom-radio mb-sm" style="margin-bottom: 0.75em;">
          <input
            :id="'match' + data.order + data.id"
            @change="updateCheck($event, 'onlyMatchmaking')"
            type="checkbox"
            :checked="data.onlyMatchmaking"
          />
          <label :for="'match' + data.order + data.id"
            >Visible only on matchmaking and contact forms</label
          >
        </div>

        <hr style="margin: 1.75em 0 1.5em;" />

        <div v-if="!newItem">
          <FilterListItem
            v-for="(option, i) in data.filterOptions"
            :key="i"
            :data="option"
            @item-change="updateHandler"
            @remove-item="
              removeOptionHandler({
                index: data.order,
                optionIndex: option.order,
              })
            "
            @remove-new-item="
              removeNewOptionHandler({
                index: data.order,
                optionIndex: option.order,
              })
            "
            @change-order="changeOrderHandler"
            :index="i"
            :last="
              option.order ===
                data.filterOptions.length - 1 - findDeleted(data.filterOptions)
            "
            :new="option.new"
          />

          <a
            class="fw-bold fc-violet fs-sm "
            @click="addNewOption({ amount, index: data.order })"
          >
            Add option <i class="fa fa-plus icon-va-md ml-xs  mt-sm mb-md"></i>
          </a>
        </div>
        <div v-else>
          <FilterListItem
            v-for="(option, i) in data.filterOptions"
            :key="i"
            :data="option"
            :last="i === data.filterOptions.length - 1"
            @item-change="updateNewFilterHandler"
            @remove-new-item="
              removeNewFilterOption({
                index: data.order,
                optionIndex: option.order,
              })
            "
            @change-order="changeOrderOfNewFilterOption"
            :new="true"
          />
          <a
            class="fw-bold fc-violet fs-sm "
            style="display: block; padding-left: 3em; cursor: pointer;"
            @click="
              addNewFilterOption({
                amount: data.filterOptions.length,
                index: data.order,
              })
            "
          >
            Add option <i class="fa fa-plus icon-va-md ml-xs  mt-sm mb-md"></i>
          </a>
        </div>
      </div>
    </div>
    <Modal
      v-if="showModal"
      okText="Delete"
      cancelText="Close"
      header="Delete filter"
      body="This action cannot be undone and will impact all partners connected to this filter, are you sure you want to delete this?"
      @cancel="showModal = false"
      @confirm="remove"
    />
  </div>
</template>

<script>
import FilterListItem from '@/components/Dashboard/SettingsFilterListItem';
import Modal from '@/components/Modal';
import { createNamespacedHelpers } from 'vuex';
import { reorderUpdateDeleteChild } from '@/utils/mixins';
const { mapGetters, mapActions } = createNamespacedHelpers('settings/filters');

export default {
  mixins: [reorderUpdateDeleteChild],
  name: 'FilterParent',
  components: {
    FilterListItem,
    Modal,
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    ...mapActions([
      'changeOptionOrder',
      'removeOption',
      'updateOption',
      'clearOptions',
      'updateNewOption',
      'removeNewOption',
      'addNewOption',
      'addNewFilterOption',
      'removeNewFilterOption',
      'updateNewFilterOption',
      'changeOrderOfNewFilterOptionHandler',
    ]),
    move(direction) {
      this.$emit('change-order', {
        direction,
        index: this.data.order,
      });
      this.$forceUpdate();
    },
    removeOptionHandler(payload) {
      this.removeOption(payload);
      this.$forceUpdate();
    },
    removeNewOptionHandler(payload) {
      this.removeNewOption(payload);
      this.$forceUpdate();
    },
    updateHandler(payload, newOption) {
      payload.index = this.data.order;
      if (!newOption) {
        this.updateOption(payload);
      } else {
        this.updateNewOption(payload);
      }
    },
    changeOrderHandler(payload) {
      payload.index = this.data.order;
      this.changeOptionOrder(payload);
      this.$forceUpdate();
    },
    updateNewFilterHandler(payload) {
      payload.index = this.data.order;
      this.updateNewFilterOption(payload);
    },
    updateCheck(event, key) {
      if (this.new) {
        this.$emit('new-item-change', {
          value: event.target.checked,
          key,
          index: this.data.order,
        });
        this.$forceUpdate();
      } else {
        this.$emit('item-change', {
          value: event.target.checked,
          key,
          index: this.data.order,
        });
      }
    },

    changeOrderOfNewFilterOption(payload) {
      payload.index = this.data.order;
      this.changeOrderOfNewFilterOptionHandler(payload);
      this.$forceUpdate();
    },

    askConfirmation() {
      this.showModal = true;
    },

    findDeleted(options) {
      const x = options.filter(option => option.delete);
      return x.length;
    },
  },
  computed: {
    ...mapGetters(['options', 'newOptions', 'newItemOptions', 'newItems']),
    amount() {
      return (
        this.options(this.data.order).length +
        this.newOptions(this.data.order).length
      );
    },
    newFilterOptionAmount() {
      return this.newItemOptions(this.data.order).length;
    },
    newItem() {
      return this.new;
    },
  },

  created() {
    if (!this.new) {
      this.clearOptions();
    }
  },
};
</script>

<style lang="scss" scoped>
.dashboard-fieldset {
  margin-left: 0;
  float: left;
  padding: 1rem;
  margin-bottom: 1.5rem;
}
</style>
